// extracted by mini-css-extract-plugin
export default {"addShipping":"Ab-z"};